import { apiGet, apiPost } from "./CustomerApi";


export async function getSubscriptionTypes() {
    const path = '/api/subscription-types';
    return apiGet(path, )
        .then(data => {return data || [];})
}

export async function getSubscriptionTiers() {
    const path = '/api/subscription-tiers';
    return apiGet(path, )
        .then(data => {return data || [];})
}

export async function saveSubscription(data) {
    const path = '/api/subscription';

    return apiPost(path, data)
        .then((data) => {return data;})

}

export async function saveSubscriptionPayment(data) {
    const path = '/api/subscription/payment';

    return apiPost(path, data)
        .then((data) => {return data;})

}

export async function editSubscriptionPayment(data) {
    const path = '/api/subscription/payment/edit';

    return apiPost(path, data)
        .then((data) => {return data;})

}

export async function cancelSubscription(data) {
    const path = '/api/subscription/cancel';

    return apiPost(path, data)
        .then((data) => {return data;})

}

export async function editSubscriptionNote(data) {
    const path = '/api/subscription/notes/edit';

    return apiPost(path, data)
        .then((data) => {return data;})

}

export async function changeSubscription(data) {
    const path = '/api/subscription/change';

    return apiPost(path, data)
        .then((data) => {return data;})

}

export async function revertSubscription(data) {
    const path = '/api/subscription/revert';

    return apiPost(path, data)
        .then((data) => {return data;})

}